const getStaffModules = (userRole, isProduction) => {
  const studentDatabasePath = userRole === 'ACCOUNTS_SECTION' ? '/accounts/students' : '/students';

  const baseModules = [
    { name: 'Staff Management', icon: 'students', path: '/admin/staff', available: true, roles: ['SUPER_ADMIN'] },
    { name: 'Department Management', icon: 'departments', path: '/admin/departments', available: true, roles: ['SUPER_ADMIN'] },
    { name: 'Student Database', icon: 'students', path: '/admin/student-management', available: true, roles: ['SUPER_ADMIN'] },
    { name: 'NOC Management', icon: 'approvals', path: '/admin/noc-management', available: true, roles: ['SUPER_ADMIN'] },
    { name: 'Mark Attendance', icon: 'attendance', path: '/attendance/mark', available: true, roles: ['FACULTY', 'HOD', 'ADMIN'] },
    { name: 'Update Grades', icon: 'grades', path: '/grades/update', available: !isProduction, roles: ['FACULTY', 'HOD', 'ADMIN'] },
    { name: 'Timetable', icon: 'event', path: '/timetable', available: !isProduction, roles: ['FACULTY', 'HOD', 'ADMIN'] },
    { name: 'Academic Events', icon: 'events', path: '/academics/internal-tests', available: !isProduction, roles: ['FACULTY', 'HOD', 'ADMIN'] },
    { name: 'NOC Approvals', icon: 'approvals', path: '/approvals', available: true, roles: ['FACULTY', 'HOD', 'ADMIN', 'LIBRARY_STAFF', 'ACCOUNTS_SECTION', 'EXAM_SECTION'] },
    { name: 'Study Materials', icon: 'materials', path: '/materials/upload', available: !isProduction, roles: ['FACULTY', 'HOD', 'ADMIN'] },
    { name: 'Students', icon: 'students', path: studentDatabasePath, available: true, roles: ['ADMIN', 'ACCOUNTS_SECTION'] },
    { name: 'Students', icon: 'students', path: '/student-managent', available: true, roles: ['FACULTY', 'HOD'] },
    { name: 'Reports', icon: 'reports', path: '/reports', available: !isProduction, roles: ['HOD', 'ADMIN'] },
    { name: 'Post Updates', icon: 'events', path: '/staff/notifications', available: true, roles: ['SUPER_ADMIN', 'ADMIN', 'HOD', 'EXAM_SECTION', 'CEO', 'PRINCIPAL', 'VICE_PRINCIPAL', 'DEAN'] },
    { name: 'Verify Payments', icon: 'fees', path: '/fees/verify', available: true, roles: ['ACCOUNTS_SECTION'] },
    { name: 'Record Payment', icon: 'fees', path: '/fees/record', available: true, roles: ['ACCOUNTS_SECTION'] },
    { name: 'Payment Logs', icon: 'fees', path: '/fees/logs', available: true, roles: ['ACCOUNTS_SECTION', 'HOD', 'EXAM_SECTION', 'SUPER_ADMIN', 'LIBRARY_STAFF'] },
  ];

  return baseModules.filter((module) => module.available && (!module.roles || module.roles.includes(userRole)));
};

const mapStaffModuleIcon = (icon) => {
  if (icon === 'fees') return 'payments';
  if (icon === 'students') return 'person';
  if (icon === 'materials') return 'book';
  if (icon === 'grades') return 'grade';
  if (icon === 'approvals') return 'description';
  return icon;
};

export const getSidebarNavItems = (user, isProduction) => {
  const studentSidebarItems = [
    { name: 'Dashboard', icon: 'dashboard', path: '/dashboard' },
    { name: 'NOC Requests', icon: 'description', path: '/noc' },
    { name: 'Attendance', icon: 'attendance', path: '/attendance' },
    { name: 'Grades', icon: 'grade', path: '/grades' },
    { name: 'Timetable', icon: 'event', path: '/timetable' },
    { name: 'Fees', icon: 'payments', path: '/fees' },
    { name: 'Documents', icon: 'folder', path: '/documents' },
    { name: 'Library', icon: 'library', path: '/library' },
    { name: 'Study Materials', icon: 'book', path: '/materials' },
    { name: 'Exam Section', icon: 'exam', path: '/exam-section' },
  ];

  if (user?.userType === 'student') {
    return studentSidebarItems;
  }
  // Special quick links for Exam Section users
  if (user?.role === 'EXAM_SECTION') {
    return [
      { name: 'Dashboard', icon: 'dashboard', path: '/dashboard' },
      { name: 'Timetable', icon: 'event', path: '/timetable' },
      { name: 'Student Database', icon: 'person', path: '/student-management' },
      // Separate subjects view for Exam section to avoid manage page access
      { name: 'Subjects', icon: 'book', path: '/timetable/subjects' },
      { name: 'Exam Timetables', icon: 'exam', path: '/exam/timetables' },
      { name: 'Exam Results', icon: 'exam', path: '/exam/results' },
    ];
  }

  const staffModules = getStaffModules(user?.role, isProduction);

  return [
    { name: 'Dashboard', icon: 'dashboard', path: '/dashboard' },
    ...staffModules.slice(0, 10).map((module) => ({
      name: module.name,
      icon: mapStaffModuleIcon(module.icon),
      path: module.path,
    })),
  ];
};

export const getMobileNavItems = (user, isProduction) => {
  return [...getSidebarNavItems(user, isProduction)];
};